:host {
    /**
    * @prop --tabs-buttons-wrapper-min-width: Set the scroll area width. Default to 250px and should not go over ~300px. As direct children is a full scrollable area, it has an automatic width set by parent.
    * @prop --tabs-buttons-list-width: Set the min-width of the tabs-buttons list. Play with this value and media queries to render an horizontal scroll area for mobile. 
    */
    --tabs-buttons-list-width: auto;
    --tabs-buttons-wrapper-min-width: 250px;

    display: block;
    position: relative;

}

.joy-tabs {
    display: grid;
    position: relative;

    &-buttons__wrapper {
        position: relative;
        width: 100%;
        background-color: transparent;
        min-width: var(--tabs-buttons-wrapper-min-width);
        box-sizing: border-box;
        display: flex;
        align-items: center;
    }

    &-scroll-right {
        padding-left: var(--joy-core-spacing-2);
        border-left: 1px solid var(--joy-color-neutral-30);
    }

    &-scroll-left {
        padding-right: var(--joy-core-spacing-2);
        border-right: 1px solid var(--joy-color-neutral-30);
    }

    &-buttons {
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
        min-width: var(--tabs-buttons-list-width);
        overflow-x: auto;
        z-index: 0;

        &:before {
            content: '';
            position: absolute;
            bottom: 0;
            height: 2px;
            width: 100%;
            background-color: var(--joy-color-neutral-30);
        }

        &__wrapper {
            position: relative;
            box-sizing: border-box;

            &--scroll-start {
                &:before {
                    content: '';
                    z-index: 1;
                    box-sizing: border-box;
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 40px;
                    border-left: 1px solid var(--joy-color-neutral-30);
                    height: calc(100% - 2px);
                    background: linear-gradient(to right, rgba(255,255,255,0.85) 0%,rgba(0,0,0,0) 100%);
                } 
            }

            &--scroll-end {
                &:after {
                    content: '';
                    z-index: 1;
                    box-sizing: border-box;
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 40px;
                    border-right: 1px solid var(--joy-color-neutral-30);
                    height: calc(100% - 2px);
                    background: linear-gradient(to right, rgba(0,0,0,0) 0%,rgba(255, 255, 255, 0.65) 100%);
                } 
            }
        }

        &::-webkit-scrollbar {
            -webkit-appearance: none;
            height: 0;
        }
    }
}